const queryGearDetail = params => {
  return `
query gearDetailQuery(
  $itemPath: String = "/sitecore/content/lynkco-global-portal/Content/Gear/${params.scBrandName}/${params.scProductName}",
  $language: String = "${params.lang}"
) {
  # Datasource query
  # $datasource will always be set to the ID of the rendering's datasource item
  # (as long as the GraphQLData helper is used)
 
  gearDetail: item(path: $itemPath, language:$language) {
    path
    displayName
    fields(ownFields:true) {
      name
      value
      ... on ImageField{
        src
        alt
        title
        height
        width
      }
      ... on FileField{
        mimeType
        size
        title
        url
      }
    }
    children {
      template {
        name
      }
      fields(ownFields: true) {
        name
        value
        ... on ImageField{
          src
          alt
          title
          height
          width
        }
      }
      children {
        template {
          name
        }
        fields(ownFields: true) {
          name
          value
          ... on ImageField{
            src
            alt
            title
            height
            width
          }
        }
      }
    }
  }  
}
`;
};

export default queryGearDetail;
